import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=34606951&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"
import style0 from "./Image.vue?vue&type=style&index=0&id=34606951&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34606951",
  null
  
)

export default component.exports